/**
 * Komunikaty błędów serwera są pisane dla programisty i często kończą się odwołaniem do
 * specyfikacji albo nazwą pola, np. „Twierdzenie wymaga niepustego uzasadnienia (`rationale`,
 * §11.3).” Właściciel archiwum widzi je wprost w oknach formularzy, więc przed pokazaniem
 * usuwamy nawiasy, które niosą WYŁĄCZNIE takie odwołania techniczne, i same znaczniki `…`.
 * Nawiasy z normalną treścią zostają. Oryginał jest nadal dostępny w `ApiError.problem`.
 */

/** Nawias techniczny: zawiera „§” albo składa się wyłącznie z nazw pól w `…` i przecinków. */
const TECHNICAL_PAREN_RE = /\s*\((?:[^()]*§[^()]*|\s*`[^`()]+`(?:\s*,\s*`[^`()]+`)*\s*)\)/gu;

/** Samodzielne odwołanie do paragrafu poza nawiasem, np. „ — §13.2 pkt 4”. */
const LOOSE_SECTION_RE = /\s*[—–-]?\s*§\s?\d+(?:\.\d+)*(?:\s+(?:pkt|wiersz)\s+[\w./-]+)?/gu;

export function humanizeServerMessage(message: string): string {
  let text = message.replace(TECHNICAL_PAREN_RE, '');
  text = text.replace(LOOSE_SECTION_RE, '');
  text = text.replace(/`([^`]+)`/gu, '$1');
  text = text
    .replace(/\s+([.,;:!?])/gu, '$1')
    .replace(/\s{2,}/gu, ' ')
    .trim();
  return text;
}
